module.exports = __webpack_public_path__ + "img/select_a_coach_bg.a7525f66.jpg";